// Agrupa opciones activas por grupo para calcular combinaciones
const groupByOptionGroupArray = (optionsProduct = []) => {
  const grouped = optionsProduct.reduce((acc, option) => {
    const groupId = option.optionGroupId;
    if (!acc[groupId]) {
      acc[groupId] = { optionGroup: option.optionGroup, options: [] };
    }
    acc[groupId].options.push(option);
    return acc;
  }, {});

  return Object.values(grouped);
};

export const buildOptionIdsForProduct = (optionsProduct = [], groupActive) => {
  const optionGroups = groupByOptionGroupArray(optionsProduct);
  const allActiveOptions = optionGroups.flatMap((item) => item.options.map((opt) => opt.optionId));
  const newOptions = (groupActive?.options || []).map((opt) => opt.optionId);

  return [...new Set(allActiveOptions.concat(newOptions))];
};

export const computeNewCombinations = (optionsProduct = [], groupActive) => {
  const optionGroups = groupByOptionGroupArray(optionsProduct);
  const totalCombinations = optionGroups.map((item) => item.options.length).reduce((acc, len) => acc * len, 1);

  const newOptionsCount = (groupActive?.options || []).length;
  return parseInt(newOptionsCount, 10) * parseInt(totalCombinations, 10);
};
